import React from "react";
import "./Loading.scss";
import Dimmer from "semantic-ui-react/dist/es/modules/Dimmer";
import Loader from "semantic-ui-react/dist/es/elements/Loader";

function Loading(props) {
    return (
        <div className="loading">
            <Dimmer inverted active>
                <Loader size="big" className="skiptranslate">
                    {props.dataUsage ? "We are  gathering your data usage this can take upto 15-30 seconds." : "Loading"}
                </Loader>
            </Dimmer>
        </div>
    );
}
export default Loading;
